import React, { PureComponent } from 'react';
import _ from 'lodash';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { defineMessages, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import {
  asyncRequestContextsSelectors,
  asyncRequestContextsActions,
} from '@lifeomic/phc-web-toolkit/src/redux/modules/asyncRequestContexts';
import { IconButton } from '@lifeomic/chroma-react/components/IconButton';
import { Send } from '@lifeomic/chromicons';
import { surveysActions } from '../../../../../redux/modules/surveys';
import { contextKeys } from '../../../../../redux/modules/asyncRequestContexts';
import NotificationHelper from '@lifeomic/phc-web-toolkit/src/redux/util/NotificationHelper';
import { patientPropsSelector } from '../../../../../redux/selectors/patientSelector';
import { questionnaireUtils } from '@lifeomic/phc-web-toolkit/src/components/Surveys';
import { Tooltip } from '@lifeomic/chroma-react/components/Tooltip';
import { projectPickerSelectors } from '@lifeomic/phc-web-toolkit/src/redux/modules/projectPicker';

const messages = defineMessages({
  surveySendSuccess: {
    id: 'subjectViewer.manageSurveys.surveySendSuccess',
    defaultMessage: 'Successfully assigned survey to subject',
  },
  surveySendFailure: {
    id: 'subjectViewer.manageSurveys.surveySendFailure',
    defaultMessage: 'Failed to assign survey to subject',
  },
  sendTooltip: {
    id: 'subjectViewer.manageSurveys.sendTooltip',
    defaultMessage: 'Assign survey to subject',
  },
  inviteSubject: {
    id: 'subjectViewer.manageSurveys.inviteSubject',
    defaultMessage: 'Invite subject to complete survey',
  },
});

const sendInviteContextKey = contextKeys.patientViewer.sendSurveyInvite;

const { isFetchingSelector: isSendingInviteSelector } =
  asyncRequestContextsSelectors.bindContextKeyToSelectors(sendInviteContextKey);

class SendSubjectSurveyButton extends PureComponent {
  getSubjectId = () =>
    patientPropsSelector(this.props.patient, false, this.props.mrnConfig).id;
  getEmail = () =>
    patientPropsSelector(this.props.patient, false, this.props.mrnConfig).email;
  getGroupId = () => _.get(this.props.subjectGroup, 'id');
  getSurveyId = () => _.get(this.props.survey, 'id');
  getIsInternalSurvey = () =>
    questionnaireUtils.isInternalSurvey(this.props.survey);

  handleSendClick = e => {
    const {
      resetContext,
      intl: { formatMessage },
      sendExistingUserSurvey,
    } = this.props;

    resetContext(sendInviteContextKey);
    const notification = new NotificationHelper(
      formatMessage(messages.surveySendSuccess),
      formatMessage(messages.surveySendFailure),
    );

    sendExistingUserSurvey(
      this.getSubjectId(),
      this.getSurveyId(),
      sendInviteContextKey,
      notification,
    );
  };

  render() {
    const {
      isSendingInvite,
      intl: { formatMessage },
    } = this.props;

    if (
      !this.getSubjectId() ||
      !this.getSurveyId() ||
      this.getIsInternalSurvey()
    )
      return null;

    return (
      <Tooltip title={formatMessage(messages.sendTooltip)}>
        <IconButton
          aria-label={formatMessage(messages.inviteSubject)}
          color="inverse"
          onClick={e => {
            e.stopPropagation();
            e.currentTarget.blur();
            this.handleSendClick(e);
          }}
          icon={Send}
          disabled={isSendingInvite}
        />
      </Tooltip>
    );
  }
}

SendSubjectSurveyButton.propTypes = {
  survey: PropTypes.object.isRequired,
  patient: PropTypes.object.isRequired,
  subjectGroup: PropTypes.object,
  mrnConfig: PropTypes.object,
};

const mapDispatchToProps = {
  resetContext: asyncRequestContextsActions.resetContext,
  sendExistingUserSurvey: surveysActions.sendExistingUserSurvey,
};

const mapStateToProps = state => ({
  isSendingInvite: isSendingInviteSelector(state),
  mrnConfig: projectPickerSelectors.selectActiveMrnConfig(state),
});

export default compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(SendSubjectSurveyButton);
